(function($, undefined) {
	'use strict';

	var changeBoxesOrder = function() {
		var btn = $(this);
		var box = btn.closest('.page-split-right-side-infos-ctn');
		var ctn = btn.closest('.right-side-boxes-ctn');
		var currPos = box.attr('data-order');
		var newPos = currPos;

		btn.hasClass('up') ? newPos = parseInt(currPos) - 1 : newPos = parseInt(currPos) + 1;

		var siblingToChange = $('.page-split-right-side-infos-ctn[data-order=' + newPos + ']');
		siblingToChange.attr('data-order', currPos).css('order', currPos);
		updateLabelLangs('boxes.order.' + siblingToChange.data('label') + '.' + box.data('page'), currPos, $('html').attr('data-all-langs'), null, true);
		
		box.attr('data-order', newPos).css('order', newPos);
		updateLabelLangs('boxes.order.' + box.data('label') + '.' + box.data('page'), newPos, $('html').attr('data-all-langs'), null, true);
	};
	
	var init = function () {
		$('.right-side-boxes-ctn').on('click', '.sort-right-side-box-btn', changeBoxesOrder);
	};
	
	$(init);
	
})(jQuery);
